import { dialogClasses, dialogTitleClasses, Theme } from '@mui/material'
import { Components } from '@mui/material/styles/components'
import { C1BorderRadius } from 'c1ui/theme/C1BorderRadius'

export const C1DialogTheme: Components<Theme>['MuiDialog'] = {
    styleOverrides: {
        root: ({ theme, ownerState }) => theme.unstable_sx({
            ...(ownerState.color === 'error' && {
                [`& .${dialogTitleClasses.root}`]: {
                    color: theme.palette.error.extraDark,
                },
            }),

            [`& .${dialogClasses.paper}`]: {
                borderRadius: C1BorderRadius.extraLarge,
            },
        }),
    },
}

export const C1DialogTitleTheme: Components<Theme>['MuiDialogTitle'] = {
    styleOverrides: {
        root: ({ theme }) => theme.unstable_sx({
            fontWeight: 500,
            padding: 4,
            pb: 2,
            fontSize: theme.typography.h3.fontSize,
            color: theme.palette.text.primary,
        }),
    },
}

export const C1DialogContentTheme: Components<Theme>['MuiDialogContent'] = {
    styleOverrides: {
        root: ({ theme }) => theme.unstable_sx({
            p: 4,
        }),
    },
}

export const C1DialogActionsTheme: Components<Theme>['MuiDialogActions'] = {
    styleOverrides: {
        root: ({ theme }) => theme.unstable_sx({
            p: 4,
            borderTop: `1px solid ${theme.palette.border.subtle}`,
        }),
    },
}
